// extracted by mini-css-extract-plugin
export default {"container":"Exhibit_container__jJ5bq","info":"Exhibit_info__u3u4u","subTitle":"Exhibit_subTitle__3wHUO"};